import { render, staticRenderFns } from "./BaseListRouterLink.vue?vue&type=template&id=3b7a1c02&scoped=true"
import script from "./BaseListRouterLink.vue?vue&type=script&lang=js"
export * from "./BaseListRouterLink.vue?vue&type=script&lang=js"
import style0 from "./BaseListRouterLink.vue?vue&type=style&index=0&id=3b7a1c02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7a1c02",
  null
  
)

export default component.exports